import template from "./degree-minute-field.html";
import "./degree-minute-field.less";

export class Controller {
	constructor($scope, $logger, eventBus, featureHelper) {
		this._scope = $scope;
		this.$logger = $logger;
		this._eventBus = eventBus;
		// eslint-disable-next-line no-useless-escape
		this.isNumber = /^(\-)?(\d*(\.|\.\d+)?)?$/;
		this.featureHelper = featureHelper;
	}

	$onInit() {
		this.field.options = this.field.Data;
		this.initialMinutes = this.fieldValue.roundedMinutes;
		this.initialDegrees = this.fieldValue.degrees;
	}

	handleMinutesChanged(newValue, oldValue) {
		this.fieldValue.roundedMinutes = this.onNumberChanged(newValue, oldValue, "roundedMinutes");

		if(this.fieldValue.roundedMinutes > 59) {
			this.fieldValue.roundedMinutes = 59;
		} else if(this.fieldValue.roundedMinutes < 0) {
			this.fieldValue.roundedMinutes = 0;
		}

		this.checkDirty();
	}

	getCoordinates() {
		if(
			this.fieldValue?.degrees === undefined 
			|| this.fieldValue?.minutes === undefined
			|| isNaN(this.fieldValue.degrees)
			|| isNaN(this.fieldValue.minutes)
		) {
			return "--empty--";
		}
		return `${this.fieldValue.degrees}° ${this.fieldValue.minutes}'`;
	}

	handleDegreesChanged(newValue, oldValue) {
		this.fieldValue.degrees = this.onNumberChanged(newValue, oldValue, "degrees");

		if(this.field.Key.Code === "TRIP.AREAS.LATITUDE.SINGLE") {
			if(this.fieldValue.degrees > 90) {
				this.fieldValue.degrees = 90;
			} else if(this.fieldValue.degrees < -90) {
				this.fieldValue.degrees = -90;
			}
		}
		else {
			if(this.fieldValue.degrees > 180) {
				this.fieldValue.degrees = 180;
			} else if(this.fieldValue.degrees < -180) {
				this.fieldValue.degrees = -180;
			}
		}

		this.checkDirty();
	}

	onNumberChanged(newValue, oldValue, propName) {
		if(newValue === "") {
			this.fieldValue[propName] = "";
			return;
		}

		return newValue.match(this.isNumber) ? newValue : oldValue;
	}

	checkDirty() {
		const isMinutesDirty = this.initialMinutes !== parseInt(this.fieldValue.roundedMinutes);
		const isDegreesDirty = this.initialDegrees !== parseInt(this.fieldValue.degrees);

		this.setFieldDirty(this.field.Id, isMinutesDirty || isDegreesDirty);
	}

	handleKeyUp(event) {
		const regex = /[0-9.-\\t]/;
		const isValid = regex.test(event.key);

		if(!isValid) {
			event.preventDefault();
		}
	}

	handleBlur() {
		this.forcePositive();

		const fullMinutes = this.fieldValue.roundedMinutes;

		this.fieldValue.minutes = Math.round(fullMinutes);
		this.fieldValue.roundedMinutes = this.fieldValue.minutes;
	}

	forcePositive() {
		if(this.fieldValue.degrees < 0) {
			this.fieldValue.isNegative = !this.fieldValue.isNegative;
			// this.setCompassDirection();
		}
		this.fieldValue.degrees = Math.abs(this.fieldValue.degrees);
		this.fieldValue.minutes = Math.abs(this.fieldValue.minutes);
		this.fieldValue.roundedMinutes = Math.abs(this.fieldValue.roundedMinutes);
	}

	getValidationStyling() {
		return this.field.hasValidationError ? "validation-error"
			: this.field.hasValidationWarning ? "validation-warning" : "";
	}
}

export default angular
	.module("vesl.components.report-form.degree-minute-field", [])
	.component("degreeMinuteField", {
		template,
		controller: Controller,
		bindings: {
			field: "<",
			fieldValue: "=",
			compassLetter: "<",
			setFieldDirty: "="
		}
	}).name;
